import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import api2 from "../../../../Component/axios_Interceptor/api2";
import { Live_itemList } from "../../../../Component/Interface/Live";
import url from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import OptionBox from "../Modal/OptionBox";
import Detail_itemInsert from "./Detail_itemInsert";
import SendPaymentModal from "../Modal/SendPaymentModal";
import { StoreInfo } from "../../../../Component/Interface/Store";

const Detail_itemList = ({
  live_finish,
  setChange_h,
  live_cancle_check,
  setLive_cancle_check,
  store_info,
}: {
  live_finish: string;
  live_cancle_check: boolean;
  setChange_h: React.Dispatch<React.SetStateAction<number>>;
  setLive_cancle_check: React.Dispatch<React.SetStateAction<boolean>>;
  store_info: StoreInfo;
}) => {
  const { seq } = useParams();
  const [change, setChange] = useState(0);
  const updateChnage = () => setChange(change + 1);

  const [originList, setOriginList] = useState<Live_itemList[]>([]); // 검사용
  const [itemlist, setItemList] = useState<Live_itemList[]>([]);
  const [searchWord, setSearchWord] = useState("");

  const setting_searchword = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSearchWord(e.target.value);
  const keyPress_keyword = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") search_productList(false);
  };

  const load_productList = async () => {
    try {
      const res = await api2.get(url.Communication_url.product_list, {
        params: { live_seq: seq },
      });
      // console.log(res.data);
      setItemList(res.data || []);
      setOriginList(res.data || []);
      setChange_h((pre) => pre + 1);
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };
  useEffect(() => {
    load_productList();
  }, [change]);

  const search_productList = async (reset: boolean) => {
    if (reset) {
      setSearchWord("");
      load_productList();
      return;
    }
    if (searchWord === "") {
      alert("상품명을 입력해주세요.");
      return;
    }

    try {
      const res = await api.get(url.Communication_url.search_product, {
        params: { live_seq: seq, search: searchWord },
      });
      // console.log(res.data);
      setItemList(res.data || []);
      setOriginList(res.data || []);
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };

  const setting_price = (
    e: React.ChangeEvent<HTMLInputElement>,
    idx: number
  ) => {
    const price = e.target.value;
    const updatedList = itemlist.map((item, i) =>
      i === idx ? { ...item, price: price } : item
    );
    setItemList(updatedList);
  };
  const setting_init_cnt = (
    e: React.ChangeEvent<HTMLInputElement>,
    idx: number
  ) => {
    const init_cnt = e.target.value;
    const updatedList = itemlist.map((item, i) =>
      i === idx ? { ...item, init_cnt: Number(init_cnt) } : item
    );
    setItemList(updatedList);
  };
  const setting_product_status = (
    e: React.ChangeEvent<HTMLSelectElement>,
    idx: number
  ) => {
    const status = e.target.value;
    const findData = itemlist.filter(
      (item) => item.product_status === "판매노출"
    );

    if (status === "판매노출" && findData.length === 1) {
      alert(
        "판매노출 상품은 하나만 가능합니다.\n기존 노출 상품을 취소 후 설정해주세요."
      );
      return;
    }

    const updatedList = itemlist
      .filter((_, i) => i === idx)
      .map((item) => ({ ...item, product_status: status }));

    setItemList(updatedList);
    product_update(true, updatedList);
  };

  // 수정사항 있는지 검사식
  const isNotModi = () => {
    const originData = originList.map(
      ({
        name,
        current_cnt,
        unique_option1,
        unique_option2,
        product_num,
        live_seq,
        product_status,
        ...rest
      }) => rest
    );
    const itemData = itemlist.map(
      ({
        name,
        current_cnt,
        unique_option1,
        unique_option2,
        product_num,
        live_seq,
        product_status,
        ...rest
      }) => rest
    );
    return JSON.stringify(originData) === JSON.stringify(itemData);
  };
  const product_update = async (gogo: boolean, list?: Live_itemList[]) => {
    if (!gogo) {
      if (isNotModi()) {
        return;
      }
    }

    let updateList;
    if (list) {
      updateList = list.map(
        ({
          name,
          current_cnt,
          unique_option1,
          unique_option2,
          product_num,
          live_seq,
          stock_check,
          ...rest
        }) => rest
      );
    } else {
      updateList = itemlist.map(
        ({
          name,
          current_cnt,
          unique_option1,
          unique_option2,
          product_num,
          live_seq,
          stock_check,
          ...rest
        }) => rest
      );
    }

    let updateList2;

    updateList2 = updateList.map((item) => {
      if (item.option_check === "y") {
        const { init_cnt, option_check, ...rest } = item;
        return rest;
      }
      const { option_check, ...rest } = item;
      return rest;
    });

    try {
      const res = await api.patch(
        url.Communication_url.product_update,
        { live_seq: seq, product_list: updateList2 },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.fail > 0) {
        alert(`수정실패 (${res.data.fail}/${res.data.total})`);
      }
      if (res.data.total === res.data.success) {
        openAlertBox();
      }
      if (res.data.success > 0) {
        if (searchWord === "") {
          load_productList();
        } else {
          search_productList(false);
        }
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };

  const [loading_onoff, setLoading_onoff] = useState(false);
  const update_cancle_check = async () => {
    if (loading_onoff) {
      return;
    }
    setLoading_onoff(true);

    // try {
    //   const res = await api.patch(url.Communication_url.update_cancle_check, {
    //     seq: seq,
    //     cancle_check: live_cancle_check ? "n" : "y",
    //   });
    //   // console.log(res.data);
    //   if (res.data === "성공") {
    //     setLive_cancle_check(!live_cancle_check);
    //   }
    // } catch (error) {
    //   console.error("데이터 로드 실패1:", error);
    // } finally {
    //   setLoading_onoff(false);
    // }
  };

  // 옵션
  const optionRef = useRef<{ setData: (data: any) => void }>(null);
  const openOptionBox = (
    yn: boolean,
    seq: number,
    product_status: string,
    live_seq: number,
    store_info: StoreInfo
  ) => {
    if (optionRef.current) {
      optionRef.current.setData({
        yn,
        seq,
        product_status,
        live_seq,
        store_info,
      });
    }
  };
  // 녹색 알림창
  const [openAlert, setOpenAlert] = useState(false);
  const openAlertBox = () => {
    setOpenAlert(true);
    setTimeout(() => {
      setOpenAlert(false);
    }, 2000);
  };

  // 정산서 모달
  const [sendType, setSendType] = useState("");
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(!visible);
  };

  return (
    <>
      <RowView2>
        <SendBtn
          onClick={() => {
            setSendType("알림톡");
            handleModal();
          }}
        >
          알림톡 보내기
        </SendBtn>
        <SendBtn2
          onClick={() => {
            setSendType("정산서");
            handleModal();
          }}
        >
          정산서 보내기
        </SendBtn2>
        <SendBtn3
          onClick={() => {
            navigator.clipboard.writeText(`https://fanbird.live/live/${seq}`);
          }}
        >
          방송 링크받기
        </SendBtn3>
      </RowView2>
      <TitleArea>상품등록</TitleArea>
      <Detail_itemInsert
        updateChnage={updateChnage}
        live_finish={live_finish}
      />

      <TitleArea>상품목록</TitleArea>
      <RowView>
        <SearchArea>
          <InputBox
            className="search"
            placeholder="상품명을 검색해주세요."
            value={searchWord}
            onChange={setting_searchword}
            onKeyPress={keyPress_keyword}
          />
          <Btn onClick={() => search_productList(false)}>검색</Btn>
          <Icon
            onClick={() => search_productList(true)}
            src={require("../../../../Image/ic_reset_black.png")}
          />
        </SearchArea>

        <RowView2>
          {/* <Btn
            className={live_cancle_check ? "white" : "gray"}
            onClick={update_cancle_check}
          >
            구매취소 {live_cancle_check ? "ON" : "OFF"}
          </Btn> */}
          <Btn
            className={isNotModi() ? "gray" : "blue"}
            onClick={() => product_update(false)}
          >
            저장
          </Btn>
        </RowView2>
      </RowView>

      <TableHear>
        <div className="idx">번호</div>
        <div>상품명</div>
        <div>가격</div>
        <div>재고</div>
        <div className="count">남은재고</div>
        <div className="btn">
          옵션
          <br />
          사용여부
        </div>
        <div>옵션</div>
        <div>상품노출</div>
      </TableHear>

      {itemlist.length === 0 && <Nonedata>등록된 상품이 없습니다.</Nonedata>}

      {itemlist.map((data, idx) => {
        const option1 = data.unique_option1?.join(",");
        const option2 = data.unique_option2?.join(",");

        return (
          <TableRow key={idx}>
            <div className="idx">{data.product_num || ""}</div>
            <div>{data.name}</div>
            <div>
              <InputBox
                type={"number"}
                value={data.price}
                disabled={!(data.product_status === "대기")}
                onChange={(e: any) => setting_price(e, idx)}
              />
            </div>
            <div>
              <InputBox
                type={"number"}
                value={data.init_cnt}
                disabled={
                  !(data.product_status === "대기") || data.option_check === "y"
                }
                onChange={(e: any) => setting_init_cnt(e, idx)}
              />
            </div>
            <div className="count">{data.current_cnt}</div>
            <div className="btn">
              {data.option_check === "n" ? (
                <YesorNo
                  onClick={() =>
                    openOptionBox(
                      false,
                      data.seq,
                      data.product_status,
                      data.live_seq,
                      store_info
                    )
                  }
                >
                  N
                </YesorNo>
              ) : (
                <YesorNo
                  className="yes"
                  onClick={() =>
                    openOptionBox(
                      true,
                      data.seq,
                      data.product_status,
                      data.live_seq,
                      store_info
                    )
                  }
                >
                  Y
                </YesorNo>
              )}
            </div>
            {data.option_check === "n" ? (
              <div>-</div>
            ) : (
              <div>
                옵션1 : {option1}
                <br />
                옵션2 : {option2}
              </div>
            )}
            <div>
              <SelectBox
                className={
                  data.product_status === "대기"
                    ? "gray"
                    : data.product_status === "판매노출"
                    ? "red"
                    : ""
                }
                value={data.product_status}
                onChange={(e: any) => setting_product_status(e, idx)}
              >
                <option value={"대기"}>대기</option>
                <option value={"판매"}>판매</option>
                <option value={"판매노출"}>판매노출</option>
              </SelectBox>
            </div>
          </TableRow>
        );
      })}

      <OptionBox ref={optionRef} updateChnage={updateChnage} />
      <AlertBox openAlert={openAlert} />
      <SendPaymentModal
        visible={visible}
        handleModal={handleModal}
        sendType={sendType}
        store_info={store_info}
      />
    </>
  );
};

export default Detail_itemList;

const GreenBox = styled(CenterView)`
  position: relative;
  flex-direction: column;
  position: fixed;
  right: 1%;
  top: 1%;
  width: 12rem;
  height: 3rem;
  ${fontStyles.medium}
  color: white;
  background-color: #38c73b;
  border-radius: 8px;
  margin-bottom: 2rem;
  transition: all 0.5s ease;
  opacity: 1;
  overflow: hidden;
  &.none {
    top: -20%;
    opacity: 0;
  }
`;
const AlertBox = (props: { openAlert: boolean }) => {
  const { openAlert } = props;
  return (
    <GreenBox className={openAlert ? "" : "none"}>수정 되었습니다.</GreenBox>
  );
};

const TitleArea = styled.div`
  margin-bottom: 1rem;
  ${fontStyles.semiBold}
  font-size: 20px;
`;
const Btn = styled.span`
  padding: 0.8rem 1.5rem;
  margin-left: 0.5rem;
  white-space: nowrap;
  ${fontStyles.semiBold}
  color: white;
  background-color: #2d2d2d;
  border-radius: 8px;
  cursor: pointer;
  &.blue {
    background: linear-gradient(135deg, #7955f0, #3209b9);
  }
  &.gray {
    color: #858585;
    background-color: #f8f8f8;
  }
  &.white {
    ${fontStyles.medium}
    color: #2d2d2d;
    background-color: white;
    border: 1px solid #8e8e8e;
  }
`;
const SearchArea = styled(RowView2)`
  flex: 1;
  max-width: 35rem;
  img {
    padding: 0.5rem;
    margin-left: 0.5rem;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
  }
`;
const InputBox = styled.input`
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  padding: 0.8rem;
  ${fontStyles.regular}
  font-size: 16px;
  border: 1px solid #f0f0f0;
  outline: 0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid #454545;
  }
  &::placeholder {
    color: #c6c6c6;
  }
  &:disabled {
    color: #8e8e8e;
    &:hover {
      border: 1px solid #f0f0f0;
    }
  }
  &.search {
    min-width: 20rem;
  }
`;
const TableHear = styled(RowView)`
  padding: 1rem 0rem;
  margin-top: 1rem;
  ${fontStyles.medium}
  background-color: #f8f8f8;
  div {
    flex: 1;
    text-align: center;
  }
  div.idx,
  div.btn {
    max-width: 4rem;
  }
  div.count {
    max-width: 5rem;
    margin-right: 1rem;
  }
`;
const TableRow = styled(RowView)`
  padding: 0.5rem 0rem;
  div {
    flex: 1;
    width: 100%;
    height: 100%;
    margin: 0rem 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-line;
    text-align: center;
    overflow: hidden;
  }
  div.idx {
    max-width: 3rem;
  }
  div.btn {
    max-width: 4rem;
  }
  div.count {
    max-width: 5rem;
    color: #ea2922;
  }
`;
const YesorNo = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  ${fontStyles.Bold}
  color: #8e8e8e;
  font-size: 14px;
  border-radius: 50px;
  background-color: #f8f8f8;
  transition: background-color 0.3s;
  cursor: pointer;
  &.yes {
    color: white;
    background-color: #2d2d2d;
  }
`;
const SelectBox = styled.select`
  width: 6rem;
  padding: 0.8rem 0rem;
  font-size: 16px;
  text-align: center;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  outline: 0;
  cursor: pointer;
  &.red {
    color: #ea2922;
    border: 1px solid #ea2922;
    background-color: #ffe9e8;
  }
  &.gray {
    color: #8e8e8e;
    background-color: #f8f8f8;
  }
`;
const Nonedata = styled(CenterView)`
  height: 10rem;
  color: #858585;
`;

const SendBtn = styled.div`
  cursor: pointer;
  background-color: #2d2d2d;
  height: 48px;
  border-radius: 8px;
  width: 136px;
  color: white;
  ${fontStyles.semiBold}
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
`;

const SendBtn2 = styled.div`
  cursor: pointer;
  background-color: white;
  height: 46px;
  border-radius: 8px;
  width: 134px;
  color: black;
  ${fontStyles.semiBold}
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  border: 1px solid #8e8e8e;
  margin-left: 16px;
`;

const SendBtn3 = styled.div`
  cursor: pointer;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  height: 46px;
  border-radius: 8px;
  width: 134px;
  color: white;
  ${fontStyles.semiBold}
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  border: 1px solid #8e8e8e;
  margin-left: 16px;
`;
